var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNervousness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 3.73029C9.62873 2.61579 8.54261 1.61221 7.35547 0.738106C7.25038 0.66449 7.12518 0.625 6.99687 0.625C6.86857 0.625 6.74337 0.66449 6.63828 0.738106C5.45332 1.61257 4.36931 2.61614 3.40625 3.73029C1.25859 6.1967 0.125 8.7967 0.125 11.2498C0.125 13.0732 0.849328 14.8219 2.13864 16.1112C3.42795 17.4005 5.17664 18.1248 7 18.1248C8.82336 18.1248 10.572 17.4005 11.8614 16.1112C13.1507 14.8219 13.875 13.0732 13.875 11.2498C13.875 8.7967 12.7414 6.1967 10.5938 3.73029ZM11.3633 11.9795C11.2012 12.8848 10.7657 13.7186 10.1153 14.3688C9.465 15.019 8.63105 15.4544 7.72578 15.6162C7.69245 15.6216 7.65876 15.6245 7.625 15.6248C7.46822 15.6248 7.31719 15.5658 7.20185 15.4596C7.08651 15.3535 7.01529 15.2078 7.00231 15.0516C6.98933 14.8953 7.03554 14.7399 7.13178 14.6162C7.22802 14.4924 7.36725 14.4093 7.52187 14.3834C8.81641 14.1655 9.91484 13.067 10.1344 11.7701C10.1621 11.6067 10.2537 11.4609 10.3889 11.3649C10.5242 11.269 10.692 11.2307 10.8555 11.2584C11.019 11.2862 11.1647 11.3778 11.2607 11.513C11.3566 11.6482 11.395 11.816 11.3672 11.9795H11.3633Z",
    fill: "url(#paint0_linear_393_82865)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_82865",
    x1: 0.125,
    y1: 18.1248,
    x2: 18.0353,
    y2: 10.8062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778899"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNervousness);
export default __webpack_public_path__ + "static/media/Nervousness.61a198e8e7101203edc45b8bac1ec2dd.svg";
export { ForwardRef as ReactComponent };